import {actions as A} from '../constants/actions';

const setRegType = regType => {
  return (dispatch) => {
    dispatch({
      type: A.SET_REG_TYPE,
      payload: {regType}
    });
  }
};

export {setRegType}
